module.exports = __webpack_public_path__ + "img/kcs-terkep2.8d0c9461.jpg";